import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, signal, WritableSignal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnimateModule } from '@pro-connect/shared';
import { IFaq } from '../../models/faq';

@Component({
  selector: 'app-pro-edu-tra-faq',
  templateUrl: './pro-edu-tra-faq.component.html',
  styleUrls: ['./pro-edu-tra-faq.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule, AnimateModule],
})
export class ProEduTraFaqComponent {
  @Input({ required: true })
  public faq!: IFaq;

  public readonly isActive: WritableSignal<boolean> = signal(false);
}
